
import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { Profile } from '@/types/database.types';

interface DebugModeProps {
  users: Profile[] | null;
  filteredUsers: Profile[] | null;
  recentUsers: Profile[];
  searchQuery: string;
  adminUsers: string[];
  error: any;
}

export const useDebugMode = ({
  users,
  filteredUsers,
  recentUsers,
  searchQuery,
  adminUsers,
  error
}: DebugModeProps) => {
  const [showDebugInfo, setShowDebugInfo] = useState(false);
  const [currentUserId, setCurrentUserId] = useState<string | null>(null);

  useEffect(() => {
    const getCurrentUser = async () => {
      if (showDebugInfo) {
        const { data } = await supabase.auth.getUser();
        if (data?.user) {
          setCurrentUserId(data.user.id);
        }
      }
    };
    
    getCurrentUser();
  }, [showDebugInfo]);

  const toggleDebugInfo = () => setShowDebugInfo(!showDebugInfo);

  // Debug data object
  const debugData = {
    rawUsers: users,
    filteredCount: filteredUsers?.length,
    recentCount: recentUsers?.length,
    searchQuery,
    adminUsers,
    error: error instanceof Error ? {
      name: error.name,
      message: error.message,
      stack: error.stack
    } : error,
    adminInfo: {
      isAdmin: true,
      uid: currentUserId
    }
  };

  return {
    showDebugInfo,
    toggleDebugInfo,
    debugData
  };
};
